module.exports = __webpack_public_path__ + "media/pan/bghead-ccbf5717.png";